import { Suspense } from "react";
import { Link, Route, Routes } from "react-router";

import { AppShell } from "./AppShell";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Home from "./routes/Home";
import Docs from "./routes/Docs";
import Privacy from "./routes/Privacy";
import Terms from "./routes/Terms";
import AcceptInvite from "./routes/AcceptInvite";
import Strategies from "./routes/Strategies";
import Trade from "./routes/Trade";
import Portfolio from "./routes/Portfolio";
import PortfolioBuild from "./routes/PortfolioBuild";
import Settings from "./routes/Settings";
import Accounts from "./routes/Accounts";

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route
          path="/invite/accept"
          element={
            <Suspense fallback={<AcceptFallback />}>
              <AcceptInvite />
            </Suspense>
          }
        />

        {/* Authenticated */}
        <Route
          path="/strategies"
          element={
            <ProtectedRoute>
              <Strategies />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trade"
          element={
            <ProtectedRoute>
              <Trade />
            </ProtectedRoute>
          }
        />
        <Route
          path="/portfolio"
          element={
            <ProtectedRoute>
              <PortfolioPageWrapper />
            </ProtectedRoute>
          }
        />
        <Route
          path="/portfolio/build"
          element={
            <ProtectedRoute>
              <PortfolioBuild />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts"
          element={
            <ProtectedRoute>
              <Accounts />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

// `/portfolio` used to wrap PortfolioContent in a container with a page heading
// in the old Next.js page.tsx. Replicated here.
function PortfolioPageWrapper() {
  return (
    <div className="container mx-auto px-4 py-8">
      <title>Portfolio | Sovrun</title>
      <h1 className="mb-6 text-2xl font-bold text-white">Portfolio</h1>
      <Portfolio />
    </div>
  );
}

function AcceptFallback() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-slate-900" />
    </div>
  );
}

function NotFound() {
  return (
    <main className="mx-auto max-w-2xl p-12">
      <title>404 — Sovrun</title>
      <h1 className="text-3xl font-bold">404 — Not found</h1>
      <p className="mt-3 text-slate-600">
        <Link to="/" className="text-sky-600 hover:underline">
          Back home
        </Link>
      </p>
    </main>
  );
}
